import {Component, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {WorkPlace} from '../../../classes/WorkPlace';
import {WorkPlaceService} from '../../../services/workplace.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmDialogComponent} from '../../dialog/confirm-dialog/confirm-dialog.component';
import {WorkPlaceEditComponent} from '../workplace-edit/workplace-edit.component';

@Component({
  selector: 'app-workplace-list',
  styleUrls: ['./workplace-list.component.scss'],
  templateUrl: './workplace-list.component.html',
})
export class WorkPlaceListComponent implements OnInit {

  public workPlaces: WorkPlace[];
  public errorMessage: string;
  private currentDialog = null;

  constructor(private workPlaceService: WorkPlaceService,
              private modalService: NgbModal) {
  }

  ngOnInit(): void {
    this.updateList();
  }

  private updateList(): void {
    this.workPlaceService.getAll()
      .subscribe({
        next: (response: WorkPlace[]) => this.workPlaces = response,
        error: (error) => this.errorMessage = error.error.error
      });
  }

  openEditModal(workPlace: WorkPlace): void {
    this.currentDialog = this.modalService.open(WorkPlaceEditComponent,
      {
        scrollable: true,
        windowClass: 'modal-workplace-edit',
        size: 'lg',
        centered: true,
      });

    this.currentDialog.componentInstance.workPlace = workPlace;

    this.currentDialog.result.then(
      (result) => {
        if (result instanceof FormGroup) {
          const editedWorkPlace = new WorkPlace(result.value);

          this.workPlaceService.addOrEdit(editedWorkPlace).subscribe({
            next: () => this.updateList(),
            error: (error) => this.errorMessage = error.error.error
          });
        }
      },
      (error) => { console.log('Dialog close error: ' + error); }
    );
  }

  openDeleteConfirmModal(workPlace: WorkPlace): void {
    this.currentDialog = this.modalService.open(ConfirmDialogComponent,
      {
        scrollable: true,
        windowClass: 'modal-confirm',
        size: 'md',
        centered: true,
        // keyboard: false,
        // backdrop: 'static'
      });

    this.currentDialog.componentInstance.message =
      'Are you sure that you want to delete workplace ' + workPlace.name + '?';

    this.currentDialog.result.then((result) => {
      if (result.status === 'confirmed') {
        this.workPlaceService.delete(workPlace.id).subscribe({
          next: () => this.updateList(),
          error: (error) => this.errorMessage = error.error.error
        });
      }
    }, (error) => {
      console.log('Dialog close error: ' + error);
    });
  }
}
